import type { UserHasFlag } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface UserHasFlagFilterProps {
  value: UserHasFlag;
  onChange: (value: UserHasFlag) => void;
}

export function UserHasFlagFilter({ value, onChange }: UserHasFlagFilterProps) {
  return (
    <div>
      <Label className="mb-1 block text-xs">Mask</Label>
      <Input
        value={value.mask}
        onChange={(e) => onChange({ mask: e.target.value })}
        placeholder="flag mask"
      />
    </div>
  );
}
